module.exports = __webpack_public_path__ + "static/media/national-geographic.81ee05da.png";